/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dynamicSort } from "../../utils/MainHelper.js";

const initialState = {
    generalMarketCategoriesData: [],
    audienceSpecificCategoriesData: [],
    categoryDeepDiveData: [],
    generateGrid: [],
    reportIsLoading: false,
    selectedGeneralMarketCategory: null,
    selectedGeneralMarketCategoryIsLoading: false,
    listOfSubItems: {},
    subItemsDataPerGroup: {},
    lowerLevelPerGroup: {},
    tilesSelected: {},
    freeForm: [],
    exactTerm: false,
    selectedQuickReport: null,
    checkedBehavioralSegments: [],
    allCategoryAnalysisTreeData: [],
    checkedWhiteSpaceSelections: [],
    freeFormValue: [],
    fullMarketTypeToAdd: "new",
    quickReportTypeToAdd: "new",
    marketCategoryTypeToAdd: "new",
    freeFormTypeToAdd: "new",
    resetDeepDiveActiveKeys: false,
    generateWhitespaceReport: false,
    masterSize: 0,
    whitespaceObj: {},
    whitespacePieValues: {},
    whitespacePieList: {},
    whitespaceSegmentSizes: {},
    currentWhitespaceTree: [],
    selectedInterestLevel: [],
    visibleAddAudienceModal: {
        trackKey: "",
        toAddNewAudience: [],
        toAddNewAudienceName: "",
        visible: false
    },
    visibleInsightsModal: {
        data: null,
        trackName: "light bulb",
        trackKey: "",
        visible: false
    },
    visiblePersonasModal: {
        data: null,
        visible: false
    },
    visibleMOKBModalSub: {
        data: null,
        visible: false
    },
    whitespaceSummary: {
        topWhitespace: [],
        topBrandSpace: []
    }
};
const reports = createSlice({
    name: "reports",
    initialState: { ...initialState },
    reducers: {
        setResetDeepDiveActiveKeys: (state, action) => {
            state.resetDeepDiveActiveKeys = action.payload;
        },
        removeCategoryDeepDiveGroup: (state, action) => {
            const { group } = action.payload;
            const filtereData = state.categoryDeepDiveData.filter((item) => item.group !== group);
            state.categoryDeepDiveData = filtereData;
        },
        setSelectedQuickReport: (state, action) => {
            state.selectedQuickReport = action.payload;
        },
        setFreeFormValue: (state, action) => {
            state.freeFormValue = action.payload;
        },
        setCheckedBehavioralSegments: (state, action) => {
            state.checkedBehavioralSegments = action.payload;
        },
        setCheckedWhiteSpaceSelections: (state, action) => {
            state.checkedWhiteSpaceSelections = action.payload;
        },
        setAllCategoryAnalysisTreeData: (state, action) => {
            state.allCategoryAnalysisTreeData = action.payload;
        },
        setGeneralMarketCategoriesData: (state, action) => {
            state.generalMarketCategoriesData = action.payload;
        },
        setAudienceSpecificCategoriesData: (state, action) => {
            state.audienceSpecificCategoriesData = action.payload;
        },
        setCategoryDeepDiveData: (state, action) => {
            state.categoryDeepDiveData = action.payload;
        },
        setGenerateGridData: (state, action) => {
            state.generateGrid = action.payload;
        },
        setSelectedInterestLevel: (state, action) => {
            const { key, value, filterInterestLevel } = action.payload
            if (key === "behaviormatch") {
                if (!value) {
                    state.selectedInterestLevel = filterInterestLevel.map((i) => i.key)
                } else {
                    state.selectedInterestLevel = []
                }
            } else if (!value && !state.selectedInterestLevel.includes(key)) {
                state.selectedInterestLevel = [...state.selectedInterestLevel, key]
            } else {
                state.selectedInterestLevel = state.selectedInterestLevel.filter((k) => {
                    if (k !== key) {
                        return k;
                    }
                })
            }
        },
        appendToGridData: (state, action) => {
            const newGridData = action.payload.reduce((acc, newData, idx) => {
                if (idx) {
                    let appended = false;
                    const newArray = acc.reduce((tempArr, stateData) => {
                        if (newData.name.includes(stateData.name) && !appended) {
                            appended = true;
                            tempArr.push(stateData);
                            tempArr.push({
                                ...newData
                                // appended: true
                            });
                        } else {
                            tempArr.push(stateData);
                        }
                        return tempArr;
                    }, []);
                    if (!appended) {
                        newArray.push({
                            ...newData
                            // appended: true
                        });
                    }
                    acc = newArray;
                } else {
                    let appended = false;
                    state.generateGrid.forEach((stateData) => {
                        if (newData.name.includes(stateData.name) && !appended) {
                            appended = true;
                            acc.push(stateData);
                            acc.push({
                                ...newData
                                // appended: true
                            });
                        } else {
                            acc.push(stateData);
                        }
                    });
                    if (!appended) {
                        acc.push({
                            ...newData
                            // appended: true
                        });
                    }
                }
                return acc;
            }, []);
            if (newGridData.length) { state.generateGrid = newGridData; }
        },
        removeToGridData: (state, action) => {
            const newList = state.generateGrid.filter((d) => d.key !== action.payload.key);
            state.generateGrid = newList;
        },
        setNewItemInCategoryDeepDive: (state, action) => {
            let lastGroup = 0;
            if (state.categoryDeepDiveData.length) {
                const groups = state.categoryDeepDiveData.map((c) => c.group);
                lastGroup = Math.max(...groups);
            }
            action.payload.forEach((newGroup) => {
                lastGroup += 1;
                state.categoryDeepDiveData.push({
                    ...newGroup,
                    group: lastGroup
                });
            });
        },
        removeSingleLoadKey: (state, action) => {
            state.categoryDeepDiveData = state.categoryDeepDiveData.map((item) => {
                const newItem = { ...item };
                delete newItem.singleLoad;
                return newItem;
            });
        },
        updateItemInCategoryDeepDive: (state, action) => {
            const { groupData, children } = action.payload;
            const groupIdx = groupData.group - 1;
            const findData = state.categoryDeepDiveData[groupIdx];
            if (findData) {
                if (findData.loading) findData.loading = false;
                if (groupData.singleLoad) findData.singleLoad = groupData.singleLoad;
                findData.children = children;
                findData.discoveredCategory = groupData.discoveredCategory;
                if (groupData.summary) findData.summary = groupData.summary;
            }
        },
        updateDeepDiveGroupData: (state, action) => {
            const { groupData, children, mergechildren } = action.payload;
            const groupIdx = groupData.group - 1;
            const findData = state.categoryDeepDiveData[groupIdx];
            if (findData) {
                if (mergechildren) {
                    const newObj = {
                        ...findData,
                        ...groupData,
                        children: [
                            ...findData.children,
                            ...children
                        ].sort(dynamicSort("-score", true))
                    };
                    delete newObj.loading;
                    state.categoryDeepDiveData[groupIdx] = newObj;
                } else {
                    state.categoryDeepDiveData[groupIdx] = {
                        ...findData,
                        ...groupData
                    };
                }
            }
        },
        removeDeepDiveItemInGroup: (state, action) => {
            const { groupData, children, fromSelectedTile } = action.payload;
            let findData = "";
            let groupIdx = 0;
            if (fromSelectedTile) {
                findData = state.selectedGeneralMarketCategory;
            } else {
                groupIdx = groupData.group - 1;
                findData = state.categoryDeepDiveData[groupIdx];
            }
            if (findData) {
                const childrenToRemove = children.map((child) => child.key);
                const newObj = {
                    ...findData,
                    children: findData.children.filter((child) => !childrenToRemove.find((key) => key === child.item))
                };

                if (fromSelectedTile) {
                    state.selectedGeneralMarketCategory = newObj;
                } else {
                    state.categoryDeepDiveData[groupIdx] = newObj;
                }
            }
        },
        setReportIsLoading: (state, action) => ({ ...state, reportIsLoading: action.payload }),
        setSelectedGeneralMarketCategory: (state, action) => ({ ...state, selectedGeneralMarketCategory: action.payload }),
        updateSelectedGeneralMarketCategory: (state, action) => {
            const { groupData, children, mergechildren } = action.payload;
            const findData = state.selectedGeneralMarketCategory;
            if (findData) {
                if (mergechildren) {
                    const newObj = {
                        ...findData,
                        ...groupData,
                        children: [
                            ...findData.children,
                            ...children
                        ].sort(dynamicSort("-score", true))
                    };
                    delete newObj.loading;
                    state.selectedGeneralMarketCategory = newObj;
                } else {
                    state.selectedGeneralMarketCategory = {
                        ...findData,
                        ...groupData
                    };
                }
            }
        },
        setSelectedGeneralMarketCategoryIsLoading: (state, action) => ({ ...state, selectedGeneralMarketCategoryIsLoading: action.payload }),
        setListOfSubItems: (state, action) => {
            const {
                group, remove, update, toUpdateIndex
            } = action.payload;
            const newObj = {
                ...state.listOfSubItems
            };
            if (remove) {
                delete newObj[group];
                state.listOfSubItems = newObj;
            } else if (update) {
                newObj[group] = newObj[group].filter((i, ix) => ix <= toUpdateIndex);
                state.listOfSubItems = newObj;
            } else {
                if (!newObj[group]) newObj[group] = [];
                newObj[group].push(action.payload);
                state.listOfSubItems = newObj;
            }
        },
        setSubItemsDataPerGroup: (state, action) => {
            const { row, subData } = action.payload;
            const { group } = row;
            state.subItemsDataPerGroup = {
                ...state.subItemsDataPerGroup,
                [group]: subData
            };
        },
        setLowerLevelPerGroup: (state, action) => {
            const { group, subData } = action.payload;
            state.lowerLevelPerGroup = {
                ...state.lowerLevelPerGroup,
                [group]: subData
            };
        },
        setFreeForm: (state, action) => {
            state.freeForm = action.payload;
        },
        setExactTerm: (state, action) => {
            state.exactTerm = action.payload;
        },
        setFullMarketTypeToAdd: (state, action) => {
            state.fullMarketTypeToAdd = action.payload;
        },
        setQuickReportTypeToAdd: (state, action) => {
            state.quickReportTypeToAdd = action.payload;
        },
        setMarketCategoryTypeToAdd: (state, action) => {
            state.marketCategoryTypeToAdd = action.payload;
        },
        setFreeFormTypeToAdd: (state, action) => {
            state.freeFormTypeToAdd = action.payload;
        },
        resetAllReportState: (state) => {
            const newState = { ...initialState };
            Object.keys(newState).forEach((key) => {
                state[key] = newState[key];
            });
        },
        resetReportState: (state, action) => {
            state.generalMarketCategoriesData = [];
            state.audienceSpecificCategoriesData = [];
            state.categoryDeepDiveData = [];
            state.generateGrid = [];
            state.resetDeepDiveActiveKeys = false;
            state.listOfSubItems = {};
            state.subItemsDataPerGroup = {};
            state.lowerLevelPerGroup = {};
            state.whitespaceObj = {};
            state.whitespacePieValues = {};
            // state.whitespaceSegmentSizes = {};
            // state.whitespacePieList = {};
            state.selectedGeneralMarketCategory = null;
            state.selectedGeneralMarketCategoryIsLoading = false;
            if (!action.payload) {
                state.reportIsLoading = false;
            }
            state.whitespaceSummary.topWhitespace = []
            state.whitespaceSummary.topBrandSpace = []
            // state.freeForm = [];
            // state.exactTerm = false;
        },
        setSummaryTopWhitespace: (state, action) => {
            state.whitespaceSummary.topWhitespace = action.payload;
        },
        setSummaryTopBrandspace: (state, action) => {
            state.whitespaceSummary.topBrandSpace = action.payload;
        },
        setMasterSize: (state, action) => {
            state.masterSize = action.payload;
        },
        setWhitespaceObj: (state, action) => {
            state.whitespaceObj = action.payload;
        },
        setWhitespacePieValues: (state, action) => {
            const { key, value } = action.payload;
            state.whitespacePieValues[key] = value;
        },
        setWhitespaceSegmentSizes: (state, action) => {
            state.whitespaceSegmentSizes = action.payload;
        },
        setWhitespacePieList: (state, action) => {
            const {
                key, value, remove, removeall
            } = action.payload;
            if (removeall) {
                state.whitespacePieList = {};
            } else {
                const copy = { ...state.whitespacePieList };
                if (remove) {
                    delete copy[key];
                } else {
                    copy[key] = value;
                }
                state.whitespacePieList = copy;
            }
        },
        setWhitespaceCurrentTree: (state, action) => {
            state.currentWhitespaceTree = action.payload;
        },
        setGenerateWhitespaceReport: (state, action) => {
            state.generateWhitespaceReport = action.payload;
        },
        setVisibleAddAudienceModal: (state, action) => {
            state.visibleAddAudienceModal = action.payload;
        },
        setVisibleInsightsModal: (state, action) => {
            state.visibleInsightsModal = action.payload;
        },
        setVisiblePersonasModal: (state, action) => {
            state.visiblePersonasModal = action.payload;
        },
        setVisibleMOKBModalSub: (state, action) => {
            state.visibleMOKBModalSub = action.payload;
        },
        setTileSelectedAll: (state, action) => {
            state.tilesSelected = action.payload;
        },
        setTileSelected: (state, action) => {
            const {
                key, remove, removeAll, data
            } = action.payload;
            let tempData = { ...state.tilesSelected };
            if (remove) {
                delete tempData[key];
            } else {
                tempData[key] = data;
            }
            if (removeAll) {
                tempData = {};
            }
            state.tilesSelected = tempData;
        },
        setReportsFromLoadedJson: (state, action) => {
            Object.keys(action.payload).forEach((key) => {
                state[key] = action.payload[key];
            });
        }
    }
});

const { reducer, actions } = reports;
export const {
    setGeneralMarketCategoriesData,
    setAudienceSpecificCategoriesData,
    setCategoryDeepDiveData,
    setGenerateGridData,
    appendToGridData,
    setReportIsLoading,
    setSelectedGeneralMarketCategory,
    setSelectedGeneralMarketCategoryIsLoading,
    updateSelectedGeneralMarketCategory,
    setListOfSubItems,
    setSubItemsDataPerGroup,
    setLowerLevelPerGroup,
    setFreeForm,
    setExactTerm,
    resetReportState,
    setNewItemInCategoryDeepDive,
    updateItemInCategoryDeepDive,
    updateDeepDiveGroupData,
    removeDeepDiveItemInGroup,
    setSelectedQuickReport,
    setCheckedBehavioralSegments,
    setCheckedWhiteSpaceSelections,
    setAllCategoryAnalysisTreeData,
    setFreeFormValue,
    removeCategoryDeepDiveGroup,
    setFullMarketTypeToAdd,
    setSelectedInterestLevel,
    setQuickReportTypeToAdd,
    setMarketCategoryTypeToAdd,
    setFreeFormTypeToAdd,
    resetAllReportState,
    setResetDeepDiveActiveKeys,
    setReportsFromLoadedJson,
    removeSingleLoadKey,
    setMasterSize,
    setWhitespacePieValues,
    setWhitespaceObj,
    setWhitespaceSegmentSizes,
    setWhitespacePieList,
    setWhitespaceCurrentTree,
    removeToGridData,
    setVisibleAddAudienceModal,
    setVisibleInsightsModal,
    setVisiblePersonasModal,
    setVisibleMOKBModalSub,
    setTileSelected,
    setTileSelectedAll,
    setSummaryTopWhitespace,
    setSummaryTopBrandspace,
    setGenerateWhitespaceReport,
} = actions;
export default reducer;
